// pages/quickbooks/callback.jsx
import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CallBack } from './Logic/QuickBooksHandler';

const QuickBooksCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing');

  useEffect(() => {
    const verifyConnection = async () => {
      const code = searchParams.get('code');
      const realmId = searchParams.get('realmId');
      const state = searchParams.get('state');

      if (!code || !realmId) {
        setStatus('error');
        return;
      }

      try {               

        const result = await CallBack(code, realmId, state, navigate);

        if (result.result) {
          setStatus('success');
          
          // Redirect to success page after 2 seconds
          setTimeout(() => {
            if (window.opener) {
              // If opened in popup, notify parent and close
              window.opener.postMessage(
                { type: 'QUICKBOOKS_CONNECTED', success: true },
                window.location.origin
              );
              window.close();
            } else {
              navigate('/quickbooks/success');
            }
          }, 2000);
        } else {
          setStatus('error');
        }
      } catch (error) {
        console.error('Verification failed:', error);
        setStatus('error');
      }
    };

    verifyConnection();
  }, [searchParams, navigate]);

  return (
    <div className="callback-container">
      {status === 'processing' && (
        <div className="processing">
          <h2>Connecting to QuickBooks...</h2>
          <p>Please wait while we verify your connection.</p>
          <div className="spinner"></div>
        </div>
      )}
      
      {status === 'success' && (
        <div className="success">
          <h2>✅ Connection Successful!</h2>
          <p>QuickBooks has been connected successfully.</p>
          <p>Redirecting you back to the application...</p>
        </div>
      )}
      
      {status === 'error' && (
        <div className="error">
          <h2>❌ Connection Failed</h2>
          <p>There was an error connecting to QuickBooks.</p>
          <button onClick={() => navigate('/settings')}>
            Back to Settings
          </button>
        </div>
      )}
    </div>
  );
};

export default QuickBooksCallback;